import React from "react";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import SlotCheckbox from "../../Components/SlotCheckbox/SlotCheckbox";
import InputErrorMessage from "../../Components/InputErrorMessage/InputErrorMessage";
import GooLoader from "../../Components/GooLoader/GooLoader";
import { Helmet } from "react-helmet-async";
import { withRouter } from "react-router-dom";
import call from "../../API/API";
import jwt_decode from "jwt-decode";
import ShushingFace from "../../assets/images/shushing-face.png";
import Briefcase from "../../assets/images/briefcase.png";
import ShoppingCart from "../../assets/images/shopping-cart.png";
import ErrorBox from "../../Components/ErrorBox/ErrorBox";
import "./PolicyAgreement.css";

class PolicyAgreement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
      showButton: false,
      first_policy: false,
      second_policy: false,
      third_policy: false,
      isLoading: true,
      errorBoxTitle: "",
      errorBoxBody: "",
    };

    this.handleFirstPolicyOnChange = this.handleFirstPolicyOnChange.bind(this);
    this.handleSecondPolicyOnChange = this.handleSecondPolicyOnChange.bind(
      this
    );
    this.handleThirdPolicyOnChange = this.handleThirdPolicyOnChange.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showErrorBox = this.showErrorBox.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (!token) {
      this.props.history.push("/");
    } else {
      let decoded = jwt_decode(token);
      if (decoded.active) {
        this.props.history.push("/dashboard");
      } else {
        if (
          this.props.location.state === undefined ||
          !this.props.location.state.userData
        ) {
          this.props.history.push("/");
        } else {
          let userData = this.props.location.state.userData;
          const { city } = userData;
          if (!city || city !== "austin") {
            this.props.history.push("/hyperlocal-networks", {
              userData: userData,
            });
          } else {
            if (
              this.props.first_policy !== "" ||
              this.props.second_policy !== ""
            ) {
              if (this.props.first_policy !== false) {
                this.setState({
                  first_policy: this.props.first_policy,
                });
              }
              if (this.props.second_policy !== false) {
                this.setState({
                  second_policy: this.props.second_policy,
                });
              }
              if (this.props.third_policy !== false) {
                this.setState({
                  third_policy: this.props.third_policy,
                });
              }
              this.setState({
                isLoading: false,
              });
            } else {
              this.setState({
                isLoading: false,
              });
            }
          }
        }
      }
    }
  }

  // componentDidMount = async () => {
  //   let token = localStorage.getItem('token')
  //   if(token === undefined) {
  //     this.props.history.push('/create-account')
  //   }else {
  //     let user_city = localStorage.getItem('city')
  //     if(user_city !== 'Austin' ) {
  //       this.props.history.push('/hyperlocal-networks')
  //     }
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.first_policy !== prevState.first_policy ||
      this.state.second_policy !== prevState.second_policy ||
      this.state.third_policy !== prevState.third_policy
    ) {
      if (
        this.state.first_policy &&
        this.state.second_policy &&
        this.state.third_policy
      ) {
        this.setState({
          showButton: true,
        });
      } else {
        this.setState({
          showButton: false,
        });
      }
    }
  }

  handleFirstPolicyOnChange(e) {
    this.props.setFirstPolicy(e.target.checked);
    this.setState({
      first_policy: e.target.checked,
    });
  }

  handleSecondPolicyOnChange(e) {
    this.props.setSecondPolicy(e.target.checked);
    this.setState({
      second_policy: e.target.checked,
    });
  }

  handleThirdPolicyOnChange(e) {
    this.props.setThirdPolicy(e.target.checked);
    this.setState({
      third_policy: e.target.checked,
    });
  }

  handleNextStep() {
    if (
      this.state.first_policy !== true ||
      this.state.second_policy !== true ||
      this.state.third_policy !== true
    ) {
      this.showErrorBox(
        "Policy agreement not accepted",
        "Please make sure to accept our policies before continuing"
      );
    } else {
      let userData = this.props.location.state.userData;
      let { user_type, city } = userData;
      let policy_agreements = {
        no_sharing_information: this.state.first_policy,
        being_professional_policy: this.state.second_policy,
      };

      call.users_API
        .finishCreatingAccount(user_type, city, policy_agreements)
        .then((res) => {
          if (res.success) {
            this.props.history.push("/payment", {
              userData: {
                ...userData,
                policy_agreements: {
                  first_policy: true,
                  second_policy: true,
                },
              },
            });
          } else {
            this.props.history.push("/error", { error: res.results });
          }
        })
        .catch((err) => {
          this.props.history.push("/error", { error: err.message });
        });
    }
  }

  showErrorBox(title, message) {
    this.setState(
      {
        errorBoxTitle: title,
        errorBoxBody: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            errorBoxTitle: "",
            errorBoxBody: "",
          });
        }, 3000);
      }
    );
  }

  handleBack() {
    this.props.history.goBack();
  }

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}

        <RegistrationForm
          showButton={this.state.showButton}
          containerClassName="container-policy-agreement"
          hasCounter={false}
          hasQuote={true}
          quote="Confidentiality and humility are two of the most important values that we uphold within Astronomic Network. We facilitate intimate business conversations between humbe professionals. You're welcome to be ambitious, competitive, protective of your time, etc. but we do not allow breaking confidentiality or exhibiting unprofessional behavior."
          headerText="Policy agreements"
          primaryButtonText="Next step"
          hasSkip={false}
          handlePrimaryBtnOnClick={this.handleNextStep}
          activatePrimaryWithEnter={true}
          showBackButton={true}
          handleBackButtonClick={this.handleBack}
          backButtonText="Back"
          hasScroller={true}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          {this.state.error !== "" ? (
            <div className="form-container-body-row">
              <InputErrorMessage errorText={this.state.error} />
            </div>
          ) : null}

          <div className="form-container-body-row">
            <SlotCheckbox
              isSelectedTrue={this.state.first_policy}
              inputHeadline={
                <>
                  <h2 className="slot-radio-headline-heading">
                    I will maintain confidentiality
                  </h2>
                  <img
                    src={ShushingFace}
                    alt="Shushing face emoji"
                    id="shishing-face-emoji"
                  />
                </>
              }
              name="first_policy"
              inputText="Do you agree to keep what's shared within your crew 100% confidential, and do you acknowledge that if you publicize or broadcast the personal, financial, or proprietary information shared by a fellow crew member outside of your crew, that we will take swift action to warn or remove you from Astronomic Network?"
              handleCheckboxChange={this.handleFirstPolicyOnChange}
            />

            <SlotCheckbox
              value="second_policy"
              name="second_policy"
              isSelectedTrue={this.state.second_policy}
              inputHeadline={
                <>
                  <h2 className="slot-radio-headline-heading">
                    I will represent myself humbly and professionally
                  </h2>
                  <img
                    src={Briefcase}
                    alt="Briefcase icon"
                    id="briefcase-emoji"
                  />
                </>
              }
              inputText="Astronomic Network is a community for empathetic entrepreneurs who treat each other with patience and selflessness. Do you agree to conduct yourself humbly and professionally at all times, or risk being swiftly warned or removed from Astronomic Network?"
              handleCheckboxChange={this.handleSecondPolicyOnChange}
            />

            <SlotCheckbox
              value="third_policy"
              name="third_policy"
              isSelectedTrue={this.state.third_policy}
              inputHeadline={
                <>
                  <h2 className="slot-radio-headline-heading">
                    No overt promotions or selling
                  </h2>
                  <img
                    src={ShoppingCart}
                    alt="Shopping cart icon"
                    id="shopping-cart-emoji"
                  />
                </>
              }
              inputText="As entrepreneurs, it’s natural for us to find business opportunities. Nonetheless, we strive to maintain a community dialogue free of promotions and spam. Do you agree to agree to refrain from promoting opportunities, deals, or causes other than in our #promotions channel, or risk being swiftly warned or removed from Astronomic Network?"
              handleCheckboxChange={this.handleThirdPolicyOnChange}
            />
          </div>
        </RegistrationForm>
        <ErrorBox
          title={this.state.errorBoxTitle}
          body={this.state.errorBoxBody}
        />
      </React.Fragment>
    );
  }
}

export default withRouter(PolicyAgreement);
